import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export default function Reports() {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const { data, isLoading } = useQuery({
    queryKey: ["reports", from, to],
    queryFn: async () => (await api.get("/reports", { params: { date_from: from || undefined, date_to: to || undefined } })).data,
  });
  const rows = data?.drivers || [];

  return (
    <div className="animate-slide-up">
      <h1 className="font-head text-2xl font-extrabold text-[#0B192C]">Driver Performance</h1>
      <p className="text-sm text-slate-500">Operational reporting — not for driver penalties</p>

      <div className="mt-4 flex flex-wrap items-center gap-3">
        <label className="text-sm text-slate-500">From <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="ml-1 rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-sm" data-testid="reports-from" /></label>
        <label className="text-sm text-slate-500">To <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="ml-1 rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-sm" data-testid="reports-to" /></label>
      </div>

      {isLoading ? <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#FF6500]" /></div> : (
        <>
          <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-4">
            <h2 className="mb-3 font-head font-bold text-[#0B192C]">Deliveries Completed by Driver</h2>
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={rows}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                <XAxis dataKey="driver" tick={{ fontSize: 12 }} />
                <YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
                <Tooltip />
                <Bar dataKey="completed" name="Completed" fill="#059669" radius={[6, 6, 0, 0]} />
                <Bar dataKey="partial" name="Partial" fill="#EA580C" radius={[6, 6, 0, 0]} />
                <Bar dataKey="failed" name="Failed" fill="#DC2626" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div className="mt-4 overflow-x-auto rounded-2xl border border-slate-200 bg-white scrollbar-thin">
            <table className="w-full text-sm" data-testid="reports-table">
              <thead><tr className="border-b border-slate-100 text-left text-xs uppercase tracking-wider text-slate-400">
                <th className="px-4 py-3">Driver</th><th className="px-4 py-3">Total</th><th className="px-4 py-3">Completed</th>
                <th className="px-4 py-3">Partial</th><th className="px-4 py-3">Failed</th><th className="px-4 py-3">Avg On Site</th>
              </tr></thead>
              <tbody>
                {rows.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-slate-400">No data for this range</td></tr>}
                {rows.map((r, i) => (
                  <tr key={i} className="border-b border-slate-50">
                    <td className="px-4 py-3 font-semibold text-[#0B192C]">{r.driver}</td>
                    <td className="px-4 py-3 text-slate-600">{r.total}</td>
                    <td className="px-4 py-3 font-semibold text-emerald-600">{r.completed}</td>
                    <td className="px-4 py-3 text-orange-600">{r.partial}</td>
                    <td className="px-4 py-3 text-rose-600">{r.failed}</td>
                    <td className="px-4 py-3 text-slate-600">{r.avg_time_on_site} min</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
